import { $api } from "@/lib/api";

// The three counters, and the nav badge — one endpoint, so the number on the
// menu and the number over the list can never disagree.
//
// `enabled` because the nav renders for every user, including those who never
// see the item: without it the request fires for people who have no business
// asking. Always call the hook and conditionally enable it — never call it
// conditionally.
export const useInboxStats = ({
  enabled = true,
}: { enabled?: boolean } = {}) => {
  const { data, isLoading, error } = $api.useQuery(
    "get",
    "/v1/inbox/stats",
    {},
    { enabled },
  );

  return {
    pending: data?.pending ?? 0,
    mine: data?.mine ?? 0,
    unassigned: data?.unassigned ?? 0,
    isLoading,
    error,
  };
};
